import { DEFAULT_SPACE_ICON, SPACE_ICONS } from '../utils/constants';
// fetch the toga appropriate icon based on value coming from API
export const getIconNameByStoredValue = (icon?: string): string => {
  return (
    Object.keys(SPACE_ICONS).find((key) => SPACE_ICONS[key] === icon) ||
    icon || // Allow passing of toga icon names
    DEFAULT_SPACE_ICON
  );
};
